<template>
  <div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
    </div>

    <s-table
      ref="table"
      size="small"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      rowKey="id"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <edit-form
      ref="editModal"
      v-if="edit_visible"
      :visible="edit_visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '@/views/a-applet/wx_mall_goods_cunsumbales/CreateForm'
import EditForm from '@/views/a-applet/wx_mall_goods_cunsumbales/EditForm'

import { listMallGoodsConsumbales, createMallGoodsConsumbales, deleteMallGoodsConsumbales, putMallGoodsConsumbales } from '@/api/applet_mall_consumbales'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    EditForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: true,
      // 创建窗口控制
      visible: false,
      edit_visible: false,
      mdl: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '100px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '商品',
          dataIndex: 'wms_goods',
          ellipsis: true
        },
        {
          title: '耗材',
          dataIndex: 'consumables',
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'count',
          ellipsis: true,
          customRender: (text) => Number(text).toFixed(2)
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return listMallGoodsConsumbales(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
      this.confirmLoading = false
    },
    handleAddCancel () {
      if (this.mdl) {
        this.edit_visible = false
        const form = this.$refs.editModal.form
        form.resetFields() // 清理表单数据（可不做）
      } else {
        this.visible = false
        const form = this.$refs.createModal.form
        form.resetFields()
      }
    },
    handleEdit (record) {
      console.log('handleEdit', record)
      this.mdl = record
      this.edit_visible = true
      this.confirmLoading = false
    },
    handleDelete (record) {
      deleteMallGoodsConsumbales(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')
        this.$refs.table.refresh()
      })
    },
    handleOk () {
      const form = this.mdl ? this.$refs.editModal.form : this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          if (this.mdl) {
            putMallGoodsConsumbales(values, this.mdl.id).then((res) => {
              console.log(res, '修改成功')
              this.edit_visible = false
              this.confirmLoading = false
              this.$refs.table.refresh()
              this.mdl = null
            })
          } else {
            createMallGoodsConsumbales(values).then((res) => {
              console.log(res, '创建成功')
              this.visible = false
              this.confirmLoading = false
              this.$refs.table.refresh()
              this.mdl = null
            })
          }
        } else {
          console.log('values---000', errors)
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
